import OptionPage from "../components/optionPageStructure";

export default function Waterpipes() {
  return (
    <OptionPage
      title="Vesiputkien reititys ja muut valinnat"
      parentCategory="Vesiputkien reititys ja muut valinnat"
      currentStep="waterpipes"
      nextRoute="/electrical-appliances"
      requireChairmanRole={true}
    />
  );
}
